import VerifyDocumentCredabilityActionTypes from './verify-document-credability.types'
import { getTransactionDataByVerificationCode } from '../../services/server-api/server-api.service'


const verifyDocumentCredabilityRequest = () => ({
  type: VerifyDocumentCredabilityActionTypes.VERIFY_DOCUMENT_CREDABILITY_REQUEST
})

const verifyDocumentCredabilitySuccess = (data) => ({
    type: VerifyDocumentCredabilityActionTypes.VERIFY_DOCUMENT_CREDABILITY_SUCCESS,
    payload: data
  })

const verifyDocumentCredabilityFailure = (error) => ({
  type: VerifyDocumentCredabilityActionTypes.VERIFY_DOCUMENT_CREDABILITY_FAILURE,
  payload: error
})


export const verifyDocumentCredability = (verificationCode) => {
  return async dispatch => {
    dispatch(verifyDocumentCredabilityRequest())
    try {
      const data = await getTransactionDataByVerificationCode(verificationCode)
      dispatch(verifyDocumentCredabilitySuccess(data))
    } catch (error) {
      dispatch(verifyDocumentCredabilityFailure({message: error.message, data: error.data}))
    }
  }
}